// JsFromRoutes CacheKey 0445d0fc9fda2d0822a7d471ab614d8a
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from 'utils/js_from_routes_client'

export default {
  index: /* #__PURE__ */ definePathHelper('get', '/members/qualifying_life_events/:qualifying_life_event_id/participants'),
  update: /* #__PURE__ */ definePathHelper('patch', '/members/qualifying_life_events/:qualifying_life_event_id/participants'),
  deleteDependent: /* #__PURE__ */ definePathHelper('delete', '/members/qualifying_life_events/:qualifying_life_event_id/participants/:participant_id'),
}
